import { cloneDeep } from 'lodash/lang'
import { selectDate } from 'lib/cart/services/selection'

const setCartDate = (state, action) => {
  const { camper, session, locationDay } = action

  // clone cart products so we don't mutate state
  const cartForm = cloneDeep(state)

  // toggle date selection for the appropriate cart product
  selectDate(locationDay, {
    camper,
    session,
    cartForm
  })

  // return a new state object
  return cartForm
}

export default setCartDate
